import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import LoaderComponent from "./LoaderComponent";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
} from "../../Util/authRedirect";
import { isOrganisationGroupUser, hasMemberOrganisationAccess } from "../../OrganisationGroups/utils/roleAccess";
import { schoolDetailAction } from "../../Redux/Action/authAction";
import { storeUser } from "../../Redux/Slice/authSlice";

const ProtectedRoutes = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const dataofstore = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(dataofstore);

  // Keep a ref of the latest userData to avoid stale closures and infinite loops in useEffect
  const userDataRef = useRef(dataofstore);
  useEffect(() => {
    userDataRef.current = dataofstore;
  }, [dataofstore]);

  // Refresh user permissions/data on every route change
  useEffect(() => {
    if (rehydrated && authToken) {
      dispatch(schoolDetailAction()).then((infoResponse) => {
        if (!infoResponse?.error && infoResponse?.payload?.data) {
          const {
            organisationGroupId,
            organisationGroupMemberships,
            groupRole,
            organisationGroupRole,
            ...restData
          } = infoResponse.payload.data;
          
          dispatch(
            storeUser({
              ...userDataRef.current,
              ...restData,
            })
          );
        }
      });
    }
  }, [location.pathname, rehydrated, authToken, dispatch]);

  if (!rehydrated) return <LoaderComponent />;

  if (!authToken) return <Navigate to="/" replace />;

  if (!hasAuthenticatedUserData(dataofstore)) return <LoaderComponent />;

  const isOnlyOrganisationUser = isOrganisationGroupUser(dataofstore) && !hasMemberOrganisationAccess(dataofstore);

  return dataofstore?.role !== "Teacher" && !isOnlyOrganisationUser ? (
    <Outlet />
  ) : (
    <Navigate to={getAuthenticatedHomeRoute(dataofstore)} replace />
  );
};

export default ProtectedRoutes;
